module.exports = __webpack_public_path__ + "img/sign-33.5cdb4ddd.jpg";